export const separator = ' • ';
